import {fieldTypes} from '@/pages/home/AddOrder/components/DynamicFormItem'


// 判断是否是下拉框
export const isLooseSelect = config => {
  return [fieldTypes.get('select').value, fieldTypes.get('multiple-select').value].includes(config.fieldType)
}

// 判断是否是日期类型
export const isDate = config => {
  return [fieldTypes.get('date').value].includes(config.fieldType)
}

// 判断是否是系统预设字段
export const isSystemField = config => {
  return config.fieldSystem === 0
}
